module.exports = __webpack_public_path__ + "static/media/marko.1ba3c3b2.jpg";